<template>
    <div id="imageMessage" class="image-message-container" :class="{ received }">
        <div
            class="sc-message--text message-bubble"
            :style="{
                ...messageColors,
                'background-color': messageColors.backgroundColor,
            }"
        >
            <viewer :id="'imageViewer-' + getId()" :images="[imageSrc()]" v-if="imageSrc()">
                <div
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('chatbotv2.imageView')"
                    class="cb-img-preview"
                    @click="show"
                    @mouseenter="hovered = true"
                    @mouseleave="hovered = false"
                >
                    <img
                        :id="'img-' + getId()"
                        :src="imageSrc()"
                        class="img-thumbnail ant-upload-list-picture-card-container"
                        style="object-fit: cover"
                    />
                    <md-icon v-if="hovered" class="cb-pr-icon"> visibility</md-icon>
                </div>
            </viewer>
            <div v-if="getCaption()" class="caption-text">
                <span class="sc-message--text-content">{{ getCaption() }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
    name: "ImageMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
        },
        received: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hovered: false,
            previewImg: false,
        };
    },
    methods: {
        getId() {
            let id = "";
            if (!!this.message.isMail) {
                id = "img-" + this.message._id;
            } else {
                id = "img-" + this.message.raw.asset._id;
            }
            return id;
        },

        show() {
            const id = this.getId();
            const prefixedId = "img-" + id;
            document.getElementById(prefixedId).click();
        },
        imageSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.raw.asset;
            }
            const path = asset?.path || "";
            if (path === "") return null;
            const isWhatsapp = path.indexOf("whatsapp") !== -1;
            const isInstagram = path.indexOf("instagram") !== -1;
            const isMessenger = path.indexOf("messenger") !== -1;
            const isTelegram = path.indexOf("telegram") !== -1;

            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger
                    ? `https://static.supsis.live/${path}`
                    : `https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
        getCaption() {
            return this.message.caption || this.message.raw?.caption || null;
        },
    },
};
</script>

<style lang="scss" scoped>
.image-message-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 0 12px;

    &.received {
        justify-content: flex-start !important;
    }
}

.message-bubble {
    display: inline-block;
    padding: 8px;
    border-radius: 6px;
    max-width: 300px;
}

.cb-img-preview {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
        max-width: 100%;
        border-radius: 4px;
    }

    .cb-pr-icon {
        position: absolute;
        z-index: 2;
    }
}

.caption-text {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
}

.cb-img-preview:hover {
    cursor: pointer;
    filter: grayscale(100%);
}

.cb-pr-icon {
    position: absolute;
    pointer-events: none;
}
</style>
<style lang="scss">
.viewer-open {
    .viewer-container {
        z-index: 9999999 !important;
    }
}
</style>
